import styled from 'styled-components';

export const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: center;
`;

export const WarningIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  & > span {
    color: ${props => props.theme.colors.warningOrange};
  }

`;

export const MessageText = styled.div`
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`;

